// A code snippet with a copy button, on the dark install pages. `onCopy(text, label)` is the
// page's — it owns the toast.
import { Box, IconButton, Tooltip } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

export default function CodeBlock({ text, copyLabel, onCopy }) {
  return (
    <Box sx={{ position: "relative", bgcolor: "#0b0b0f", border: "1px solid #26262f", borderRadius: 2, p: 2 }}>
      <Box component="pre" sx={{ m: 0, fontFamily: "monospace", fontSize: 13,
           whiteSpace: "pre-wrap", wordBreak: "break-all", color: "#d6d6e0" }}>
        {text}
      </Box>
      <Tooltip title={`Copy ${copyLabel}`}>
        <IconButton size="small" sx={{ position: "absolute", top: 8, right: 8, color: "#aaa" }}
                    onClick={() => onCopy(text, copyLabel)}>
          <ContentCopyIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </Box>
  );
}
